"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
function _interopNamespaceCompat(e) {
  if (e && typeof e === "object" && "default" in e) return e;
  const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
  if (e) {
    for (const k in e) {
      n[k] = e[k];
    }
  }
  n.default = e;
  return Object.freeze(n);
}
const React__namespace = /* @__PURE__ */ _interopNamespaceCompat(React);
const useSync = (channelName, callback) => {
  const broadcastChannelRef = React__namespace.useRef(null);
  const getChannel = React__namespace.useCallback(() => {
    if (!broadcastChannelRef.current) {
      broadcastChannelRef.current = new BroadcastChannel(channelName);
    }
    return broadcastChannelRef.current;
  }, [channelName]);
  const broadcastUpdate = () => {
    const channel = getChannel();
    channel.postMessage("update");
  };
  React__namespace.useEffect(() => {
    const channel = getChannel();
    if (callback) {
      channel.onmessage = () => {
        callback();
      };
    }
    return () => {
      channel.close();
      broadcastChannelRef.current = null;
    };
  }, [callback, getChannel]);
  return { broadcastUpdate, getChannel };
};
exports.useSync = useSync;
//# sourceMappingURL=use-sync.js.map
